import React from 'react';
import { Redirect } from 'react-router-dom';
import { defaultRoutes } from '../routing';

const NotFound = () => (<Redirect to={defaultRoutes.root} />);

export default NotFound;